// Utilities for managing document titles across the app in a consistent way

const TITLE_SUFFIX = " | Eddy - the Educator's Buddy";
const DEFAULT_DOCUMENT_TITLE = "Eddy - the Educator's Buddy";

/**
 * Formats a raw title by appending the standard suffix.
 * Falls back to default when the raw title is empty/undefined/null.
 */
export function formatDocumentTitle(rawTitle) {
  if (!rawTitle || typeof rawTitle !== "string") {
    return DEFAULT_DOCUMENT_TITLE;
  }
  const trimmed = rawTitle.trim();
  if (trimmed.length === 0) {
    return DEFAULT_DOCUMENT_TITLE;
  }
  // Avoid duplicating suffix if caller passes a fully composed title
  if (trimmed.endsWith(TITLE_SUFFIX)) {
    return trimmed;
  }
  return `${trimmed}${TITLE_SUFFIX}`;
}

/**
 * Sets the document title using the standard formatting rules.
 */
export function setDocumentTitle(rawTitle) {
  if (typeof document !== "undefined") {
    document.title = formatDocumentTitle(rawTitle);
  }
}

/**
 * Resolves a title from a route meta definition.
 * - If meta.title is a string, use it
 * - If meta.title is a function, call it with the route to get the string
 */
export function resolveRouteMetaTitle(route) {
  const metaTitle = route && route.meta ? route.meta.title : undefined;
  if (typeof metaTitle === "function") {
    try {
      const value = metaTitle(route);
      return typeof value === "string" ? value : undefined;
    } catch (e) {
      // Silently ignore title resolution errors; fall back to default
      return undefined;
    }
  }
  return typeof metaTitle === "string" ? metaTitle : undefined;
}

/**
 * Applies the route meta title to document.title, or falls back to default.
 */
export function setDocumentTitleFromRoute(route) {
  const title = resolveRouteMetaTitle(route);
  setDocumentTitle(title);
}

export { DEFAULT_DOCUMENT_TITLE };
